import React from 'react';
import { observer } from 'mobx-react-lite';

import bgNewFirstScreen2 from './img/bgNewFirstScreen2.jpg';
import bgNewFirstScreen2Male from './img/bgNewFirstScreen2Male.jpg';
import realPhotoFemale1 from './img/realPhotoFemale1.jpg';
import realPhotoMale1 from './img/realPhotoMale1.jpg';
import pinterestRealFemale from './img/pinterestFemale.jpg';
import pinterestRealMale from './img/pinterestMale.jpg';

import s from './index.module.scss';
import RealPhotoV2 from './realPhotoV2/realPhotoV2';
import Timer from '../../../components/timer';
import checkTheme from '../../../../../../src/utils/custom/checkTheme';
import { useT } from '@hooks';
import { appStore } from '@store';

const MainScreen = observer(({ showTitle = true }) => {
	const { T } = useT();
	const { goal } = appStore.surveyStore.answers;
	const { sourceSearchParams } = appStore;
	let gender = appStore.params.gender;
	const pinterest = sourceSearchParams.get('pinterest') === 'true';

	if (gender === 'other') gender = 'female';

	const goalTitle = goal ? goal[0] : 'lose_weight';

	let imgStyleFemale = bgNewFirstScreen2;
	let imgStyleMale = bgNewFirstScreen2Male;
	if (sourceSearchParams.get('realPhoto') === 'true') {
		gender === 'male' ? (imgStyleMale = realPhotoMale1) : (imgStyleFemale = realPhotoFemale1);
	}
	const realPhotoV2 = sourceSearchParams.get('realPhoto') !== 'true';

	let imgTitleText = T('losing_weight');

	if (goalTitle === 'lose_weight') {
		imgTitleText = T('losing_weight');
	} else if (goalTitle === 'gain_muscles') {
		imgTitleText = T('building_muscles');
	} else if (goalTitle === 'gain_muscles_female') {
		imgTitleText = T('building_muscles');
	} else {
		imgTitleText = T('fitness_plan');
	}

	if (pinterest) {
		imgTitleText = T('losing_weight_pinterest');
		imgStyleMale = pinterestRealMale;
		imgStyleFemale = pinterestRealFemale;
	}

	let timerMode;
	if (appStore.paymentStore.isShowTimer) {
		timerMode = 'timerMode';
	}

	return (
		<>
			{appStore.paymentStore.isShowTimer && <Timer />}
			<div className={`${s.mainScreen} ${s[timerMode]} ${s[checkTheme()]}`}>
				{showTitle && <h1 className={s.mainScreenTitle}>{imgTitleText}</h1>}
				<p className={s.mainScreenSubtitle}>{T('realPhotoV2_subtitle_v2')}</p>
				{!realPhotoV2 ? (
					<div className={s.imgWrapper}>
						{gender !== 'male' && <img src={imgStyleFemale} alt='before and after image' />}
						{gender === 'male' && <img src={imgStyleMale} alt='before and after image' />}
					</div>
				) : (
					<RealPhotoV2 />
				)}
			</div>
		</>
	);
});

export default MainScreen;
